import { Controller } from "stimulus"

/**
 * A simple business lookup controller for forms that need to select a business.
 * Searches businesses and sets a hidden field with the selected business ID.
 * Uses innerHTML for server-rendered HTML from trusted Rails endpoints (same pattern as business_select_controller).
 *
 * Targets:
 *   - searchInput: The text input for searching
 *   - results: The container for search results
 *   - hiddenField: The hidden field that stores the business_id
 *   - selectedDisplay: Shows the currently selected business name
 *   - searchArea: The search input area (hidden when business is selected)
 */
let delayTimer;

export default class extends Controller {
  static targets = ["searchInput", "results", "hiddenField", "selectedDisplay", "searchArea", "businessLink"]

  connect() {
    // Hide results initially
    if (this.hasResultsTarget) {
      this.resultsTarget.classList.add("hidden")
    }
  }

  search(e) {
    clearTimeout(delayTimer)
    if (!this.hasSearchInputTarget) return
    const query = this.searchInputTarget.value

    if (query.length < 3) {
      this.resultsTarget.classList.add("hidden")
      return
    }

    delayTimer = setTimeout(() => {
      const url = `/search/business_query.html?search=${encodeURIComponent(query)}&contractors_only=false&active=true`

      fetch(url)
        .then(response => response.text())
        .then(html => {
          // innerHTML used for trusted server-rendered content from Rails endpoint
          this.resultsTarget.innerHTML = html
          this.resultsTarget.classList.remove("hidden")
          // Add click handlers to results
          this.resultsTarget.querySelectorAll("a").forEach(link => {
            link.addEventListener("click", (e) => this.selectBusiness(e))
          })
        })
    }, 400)
  }

  selectBusiness(e) {
    e.preventDefault()
    const link = e.target.closest("a")
    const businessId = link.id
    const businessName = link.querySelector(".result-primary").textContent

    // Set the hidden field value
    this.hiddenFieldTarget.value = businessId

    // Update the business link
    if (this.hasBusinessLinkTarget) {
      this.businessLinkTarget.href = `/businesses/${businessId}`
      this.businessLinkTarget.textContent = businessName
    }

    // Show the selected display
    this.selectedDisplayTarget.classList.remove("hidden")

    // Hide search area and results
    this.searchAreaTarget.classList.add("hidden")
    this.resultsTarget.classList.add("hidden")
    this.searchInputTarget.value = ""
  }

  clear(e) {
    e.preventDefault()
    // Clear the hidden field
    this.hiddenFieldTarget.value = ""

    // Clear the business link
    if (this.hasBusinessLinkTarget) {
      this.businessLinkTarget.href = "#"
      this.businessLinkTarget.textContent = ""
    }

    // Hide the selected display
    this.selectedDisplayTarget.classList.add("hidden")

    // Show the search area
    this.searchAreaTarget.classList.remove("hidden")
  }

  // Close results when clicking outside
  closeResults(e) {
    if (this.hasResultsTarget && !this.element.contains(e.target)) {
      this.resultsTarget.classList.add("hidden")
    }
  }
}
